//** Component  */
import React from "react";
import { CCol, CFormGroup, CInput, CInputCheckbox, CInputGroup, CInputGroupPrepend, CInputGroupText, CLabel, CSelect } from "@coreui/react";
import Validation from "../../components/common/validation/ValidationText";

const FormFieldGroup = (props) => {
  return (
    <>
      <CCol md={props.column.md} lg={props.column.lg} xl={props.column.xl} className={props.column.colClass} style={{ display: props.column.display, alignItems: props.column.align }}>
        <CFormGroup className={props.column.groupClass} variant={props.column.inputType != 'checkbox' ? null : 'checkbox'}>

          {/************* Used for input type text *************/}
          {props.column.inputType === "text" || props.column.inputType === "password" ? <>
            <CLabel htmlFor={props.column.fieldName} className={props.column.labelClass}>
              {props.column.tittle} <code>{props.column.validation ? '*' : null}</code>
            </CLabel>
            <CInput className={props.column.inputClass}
              type={props.column.inputType}
              id={props.column.fieldName}
              placeholder={props.column.placeholder}
              value={props.value}
              onChange={props.onChange}
              disabled={props.column.disabled}
              onKeyPress={props.onKeyPress}
              onBlur={() => props.onBlur(props.column.fieldName)} />
          </> : null}

          {/************ Used for input type select *************/}
          {props.column.inputType === "select" ? <>
            <CLabel htmlFor={props.column.fieldName}>
              {props.column.tittle} <code>{props.column.validation ? '*' : null}</code>
            </CLabel>
            <CSelect class="form-select" id={props.column.fieldName}
              value={props.value}
              onChange={props.onChange}
              onBlur={props.onBlur} >
              {props.column.placeholder != "" ?
                <option value="0" disabled>{props.column.placeholder}</option>
                : null}
              {props.options?.map((list, index) => (
                <option key={index} value={list.id} name={list.name}>{list.name}</option>
              ))}
            </CSelect>
          </> : null}

          {/************ Used for input type checkbox *************/}
          {props.column.inputType === "checkbox" ? <>
            <CInputCheckbox id={props.column.fieldName} name={props.column.fieldName}
              checked={props.checked} onChange={props.onChange} />
            <CLabel variant="checkbox" className="form-check-label" htmlFor={props.column.fieldName}>
              {props.column.tittle}
            </CLabel>
          </> : null}

          {/************ Used for input type checkbox with label *************/}
          {props.column.inputType === "checkboxWithLabel" ? <>
            <CInputGroup className="mb-2">
              <CInputGroupPrepend>
                <CInputGroupText className="bg_check">
                  <input type="checkbox" disabled={props.disabled}
                    checked={props.checked}
                    onChange={props.onChange} />
                </CInputGroupText>
              </CInputGroupPrepend>
              <CInputGroupText className="bg_check">{props.column.tittle}</CInputGroupText>
            </CInputGroup>
          </> : null}

          {props.column.inputType != 'checkbox' ?
            <Validation className="text-left" errorText={props.error} /> : null}
        </CFormGroup>
      </CCol>

    </>
  );
};

export default FormFieldGroup;
